import { create } from 'zustand';
import { platformEvents } from '@quickbee/events';

// src/store/authStore.ts
var initialState = {
  user: null,
  tenantConfig: null,
  isAuthenticated: false,
  isLoading: true,
  kycTier: null,
  roles: [],
  accessToken: null
};
var useAuthStore = create((set) => ({
  ...initialState,
  setUser: (user) => set({
    user,
    isAuthenticated: true,
    isLoading: false,
    kycTier: user.kycTier,
    roles: user.roles
  }),
  setSession: ({ user, accessToken }) => set({
    user,
    accessToken,
    isAuthenticated: true,
    isLoading: false,
    kycTier: user.kycTier,
    roles: user.roles
  }),
  setAccessToken: (accessToken) => set({ accessToken }),
  clearAuth: () => set({ ...initialState, isLoading: false }),
  setLoading: (loading) => set({ isLoading: loading }),
  setTenantConfig: (tenantConfig) => set({ tenantConfig })
}));
var authEvents = {
  on: (event, handler) => platformEvents.on(event, handler),
  off: (event, handler) => platformEvents.off(event, handler),
  emit: (event, payload) => platformEvents.emit(event, payload)
};

export { authEvents, useAuthStore };
//# sourceMappingURL=chunk-XW7GX6IX.js.map
//# sourceMappingURL=chunk-XW7GX6IX.js.map